module.exports = __webpack_public_path__ + "img/kiali.68c5666c.svg";